<ng-container *ngIf="selectedMachine">
  <div class="fc-machine-info">

    <img *ngIf="selectedMachine.imageStr"
         class="fc-machine-image"
         [src]="selectedMachine.imageStr"
         alt="Machine image" />

    <div class="fc-info-grid">
      <div class="fc-info-item">
        <span class="fc-info-label">Serial number</span>
        <span class="fc-info-value fc-mono">{{ selectedMachine.serialNumber }}</span>
      </div>
      <div class="fc-info-item">
        <span class="fc-info-label">Year</span>
        <span class="fc-info-value fc-mono">{{ selectedMachine.year }}</span>
      </div>
      <div class="fc-info-item">
        <span class="fc-info-label">Machine</span>
        <span class="fc-info-value">{{ selectedMachine.name }}</span>
      </div>
      <div class="fc-info-item">
        <span class="fc-info-label">Operator</span>
        <span class="fc-info-value">{{ selectedMachine.operator }}</span>
      </div>
    </div>

    <button
      class="fc-error-list-btn"
      (click)="onErrorListButtonClicked()"
    >
      <span class="material-icons fc-btn-icon">error_outline</span>
      Error list
    </button>

  </div>
</ng-container>
